import { render, staticRenderFns } from "./modal2fa.vue?vue&type=template&id=1d052ee4&scoped=true&"
import script from "./modal2fa.vue?vue&type=script&lang=js&"
export * from "./modal2fa.vue?vue&type=script&lang=js&"
import style0 from "./modal2fa.vue?vue&type=style&index=0&id=1d052ee4&scoped=true&lang=scss&"
import style1 from "./modal2fa.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d052ee4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardActions,VCol,VDialog,VSpacer,VTextField})
